// extracted by mini-css-extract-plugin
export default {"code":"code-block_code__MZeWJ"};